import { updateField } from 'vuex-map-fields'
import Vue from 'vue'

const SET_REVIEW_PROJECT = (state, payload) => {
  state.reviewProject = payload
}

const SET_PROJECTS_REBUTTALS = (state, payload) => {
  state.projectsRebuttals = payload
}

const SET_PROJECTS_REBUTTALS_BACKUP = (state, payload) => {
  state.projectsRebuttalsBackup = payload
}

const SET_PROJECT_REBUTTALS_SELECTED = (state, payload) => {
  payload.projectsRebuttals.forEach(x => {
    let found = state.projectsRebuttals.find(y => ((x.coderId && y.coderId === x.coderId) || (x.hiaCoderId && y.hiaCoderId === x.hiaCoderId)) && y.recordType === payload.recordType)
    if (found) {
      found.selected = x.selected
    }
  })
  state.projectsRebuttals = [...state.projectsRebuttals] // copy the array to trigger reactivity
}

const SET_PROJECTS_REBUTTALS_SELECTEDCODETYPES = (state, payload) => {
  payload.projectsRebuttals.forEach(x => {
    let found = state.projectsRebuttals.find(y => ((x.coderId && y.coderId === x.coderId) || (x.hiaCoderId && y.hiaCoderId === x.hiaCoderId)) && y.recordType === payload.recordType)
    if (found) {
      found.projectRebuttalId = x.projectRebuttalId
      found.selectedCodeTypes = JSON.parse(x.selectedCodeTypes)
    }
  })
  state.projectsRebuttals = [...state.projectsRebuttals] // copy the array to trigger reactivity
  state.projectsRebuttalsBackup = JSON.parse(JSON.stringify(state.projectsRebuttals))
}

const SET_REBUTTALS_NOTIFICATIONS = (state, payload) => {
  state.rebuttalsNotifications = payload
}

const SET_PROJECTS_CODETYPELIST = (state, payload) => {
  state.codeTypeList = payload
}

const SET_PROJECTS_REBUTTAL = (state, payload) => {
  const index = state.projectsRebuttals.findIndex(x => x.projectRebuttalId === payload.projectRebuttalId)
  payload.selectedCodeTypes = JSON.parse(payload.selectedCodeTypes)
  // state.rebuttals[index] = payload
  // console.log(state.rebuttals)
  // state.rebuttals.splice(index, 1, payload)
  Vue.set(state.projectsRebuttals, index, payload)
  state.projectsRebuttalsBackup = JSON.parse(JSON.stringify(state.projectsRebuttals))
}

export default {
  updateField,
  SET_REVIEW_PROJECT,
  SET_PROJECTS_REBUTTALS,
  SET_PROJECT_REBUTTALS_SELECTED,
  SET_REBUTTALS_NOTIFICATIONS,
  SET_PROJECTS_CODETYPELIST,
  SET_PROJECTS_REBUTTALS_BACKUP,
  SET_PROJECTS_REBUTTALS_SELECTEDCODETYPES,
  SET_PROJECTS_REBUTTAL
}
